import React from 'react';
import image1 from './../../../data/other/8thimg.jpg';
import image2 from './../../../data/other/9thimg.jpg';
import image3 from './../../../data/other/10thimg.jpg';

const BlogAndLatestNews = () => {
  const data = [
    {
      img: image1,
      description: 'Beyond Automation, The Art and Science of Robotic Arms',
      name: 'John Doe',
      date: 'January 28, 2024',
      btnValue: 'Tips & Trick',
    },
    {
      img: image2,
      description: 'Exploring the Latest in Robotic Arm Technology',
      name: 'John Doe',
      date: 'January 28, 2024',
      btnValue: 'Tips & Trick',
    },
    {
      img: image3,
      description: 'From Assembly Lines to Precision Partners',
      name: 'John Doe',
      date: 'January 28, 2024',
      btnValue: 'Insight',
    },
  ];

  return (
    <div className="w-full min-h-[400px] flex flex-col mt-16 p-5 bg-gradient-to-bl from-slate-900 via-blue-900 to-indigo-950 relative overflow-hidden">

      {/* Background Animated Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(29,78,216,0.2),transparent_70%)] blur-3xl animate-glow"></div>

      {/* Section Heading */}
      <div className="w-full flex flex-col items-center justify-center text-center relative z-10">
        <h1 className="text-cyan-300 font-serif font-semibold text-lg md:text-xl tracking-wide animate-fadeIn">
          Our Blog
        </h1>
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white drop-shadow-[0_0_15px_rgba(0,255,255,0.5)] animate-slideUp">
          Latest News & Updates
        </h1>
      </div>

      {/* Blog Card Container */}
      <div className="w-full my-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 relative z-10">
        {data.map((v, index) => (
          <div
            key={index}
            className="group w-full flex flex-col items-center bg-white/10 backdrop-blur-md p-6 rounded-3xl 
              shadow-[0_0_30px_rgba(0,0,0,0.3)] hover:shadow-[0_0_40px_rgba(59,130,246,0.7)] 
              transform transition-all duration-700 hover:scale-[1.05] hover:-translate-y-2
              border border-blue-400/20 hover:border-blue-400/60"
          >
            {/* Image Wrapper */}
            <div className="relative w-full max-w-xs sm:max-w-md lg:max-w-lg overflow-hidden rounded-3xl">
              <img
                src={v.img}
                alt=""
                className="w-full h-auto rounded-3xl transition-transform duration-700 group-hover:scale-110 group-hover:rotate-1"
              />
              <button
                className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white font-semibold rounded-full p-2 w-[120px] absolute bottom-3 md:bottom-5 left-5
                shadow-[0_0_10px_rgba(59,130,246,0.7)] hover:shadow-[0_0_25px_rgba(99,102,241,1)] 
                transition-all duration-500 hover:scale-110 hover:bg-indigo-600"
              >
                {v.btnValue}
              </button>
            </div>

            {/* Description */}
            <p className="text-lg md:text-xl lg:text-2xl font-bold mt-6 text-center text-white leading-snug 
              hover:text-cyan-300 transition-all duration-500 drop-shadow-[0_0_10px_rgba(59,130,246,0.5)]">
              {v.description}
            </p>

            {/* Author & Date */}
            <div className="flex flex-row gap-x-2 text-sm md:text-base mt-4 text-gray-300 items-center">
              <span className="text-gray-400">by</span>
              <p className="text-blue-400 font-semibold hover:text-cyan-300 transition-all duration-300">
                {v.name}
              </p>
              <p className="text-gray-500 italic">{v.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogAndLatestNews;

/* 
💠 Add this to your global CSS (index.css or tailwind.css)

@keyframes glow {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
  }
  100% {
    opacity: 0.8;
    transform: scale(1);
  }
}

.animate-glow {
  animation: glow 6s infinite ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fadeIn {
  animation: fadeIn 1s ease-out;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-slideUp {
  animation: slideUp 1s ease-out;
}
*/
